if (!customElements.get('modal-js-wrapper')) {
    class ModalJsWrapper extends HTMLElement {
        constructor() {
          super();
          this.parentModal = this.closest('.modal-custom') ?? "";
          this.appContainer = this.querySelector('.biscuits-bundle-form') ?? "";
          this.step = 1;
          this.maxSteps = 1;
          this.atcButton = '';
          this.prevButton = '';
          this.nextButton = '';
        }
    
        connectedCallback() {
            console.log(this.appContainer, 'app container?');
            this.setupBundleSteps();
        }
        
        setupBundleSteps() {
            const steps = this.appContainer.querySelectorAll('biscuits-bundle-step') ?? [];

            this.maxSteps = steps.length;

            console.log(this.maxSteps, 'what is the maximum step?');
    
            if (!steps) return;
            
            if (this.parentModal) {
                const headerContainer = this.parentModal.querySelector('.modal-header-content-container') ?? "";
                
                const beforeArrow = `
                <button class="step-prev" data-step="" disabled>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 8L1 8M1 8L8 1M1 8L8 15" stroke="#030911" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
                `;
                
                headerContainer.insertAdjacentHTML('afterbegin', beforeArrow);
            }

            const stepFooter = this.appContainer.querySelector('.biscuits-bundle-actions') ?? "";

            if (stepFooter) {
                const buttonMarkup = `
                    <div class="before-next-buttons">
                        <button class="button button--primary next-button step-next" data-step="">Next</button>
                    </div>
                `;

                stepFooter.insertAdjacentHTML('beforeend', buttonMarkup);

                if (this.step == 1 && this.maxSteps !== 1) {
                    this.atcButton = stepFooter.querySelector('.biscuits-bundle-add-to-cart__container') ?? "";

                    if (this.atcButton) {
                        this.atcButton.classList.add('hidden');
                    }
                }
            }
    
            steps.forEach(step => {
                const stepNum = parseInt(step.dataset.biscuitsStep) ?? undefined;
    
                console.log(stepNum, 'curr step num?');
                if (stepNum != 1) {
                    step.classList.add('off-screen');
                }
            });
    
            this.setupBundleStepListeners();
        }
    
        setupBundleStepListeners() {
            this.nextButton = this.appContainer.querySelector('.step-next') ?? "";

            this.parentModal.addEventListener('click', (e) => {
                console.log(e.target.closest(".step-next"),);
                const prevButton = e.target.closest('.step-prev') ?? "";
                const nextButton = e.target.closest('.step-next') ?? "";
    
                if (nextButton) {
                    console.log(this.step, 'thec urrent step');
                    let nextStep = this.step + 1;
    
                    const currAccordion = this.querySelector(`[data-biscuits-step="${this.step}"]`) ?? "";
                    const nextAccordion = this.querySelector(`[data-biscuits-step="${nextStep}"]`) ?? "";
    
                    if (nextAccordion) {
                        nextAccordion.classList.remove('off-screen');
                        nextAccordion.classList.add('on-screen');

                        if (this.step) {
                            currAccordion.classList.remove('on-screen');
                            currAccordion.classList.add('off-screen');

                            this.step++;
                        }
                    }
                    console.log(nextAccordion, 'the next one?', nextStep);
                }

                this.prevButton = this.parentModal.querySelector('.step-prev') ?? "";

                console.log(prevButton,' does the button exist?');
                if (prevButton) {
                    if (this.step !== 1){
                        let prevStep = this.step - 1;

                        const currAccordion = this.querySelector(`[data-biscuits-step="${this.step}"]`) ?? "";
                        const prevAccordion = this.querySelector(`[data-biscuits-step="${prevStep}"]`) ?? "";

                        if (prevAccordion) {
                            prevAccordion.classList.remove('off-screen');
                            prevAccordion.classList.add('on-screen');
    
                            if (this.step) {
                                currAccordion.classList.remove('on-screen');
                                currAccordion.classList.add('off-screen');
    
                                this.step--;
                            }
                        }
                    }
                }

                if (this.step === 1) {
                    this.prevButton.disabled = true;
                } else if (this.step > 1){
                    this.prevButton.disabled = false;
                    this.nextButton.disabled = false;
                }

                if (this.step === this.maxSteps) {
                    this.nextButton.disabled = true;

                    if (this.atcButton) {
                        this.atcButton.classList.remove('hidden');
                    }
                } else if (this.step < this.maxSteps) {
                    this.atcButton.classList.add('hidden');
                } 
                
            });
        }
      }
      
    customElements.define('modal-js-wrapper', ModalJsWrapper);      
}